import Icon from "assets/icons";
import { ParticipantDetailsPropTypes } from "./types";
import { useCopies } from "shared/hooks/useCopies";

function ParticipantDetails(props: ParticipantDetailsPropTypes) {
  const copies = useCopies();
  return (
    <div className="paymentWrapper_header paymentWrapper_headerInvPayer">
      <p className="paymentWrapper_headerInvPayer--text">
        {copies.get("invoice.payment.doing.payment.for.participant")}
      </p>
      <div className="paymentWrapper_headerInvPayerInfo">
        <p className="paymentWrapper_headerInvPayerInfo--fullName">{props.fullName}</p>
        {props.organizationName ? (
          <p className="paymentWrapper_headerInvPayerInfo--orgName">
            <Icon.OrgDefaultLogoThick /> {props.organizationName}
          </p>
        ) : null}

        {props.workEmail ? (
          <p className="paymentWrapper_headerInvPayerInfo--orgEmail">
            <Icon.EmailOutline />
            {props.workEmail}
          </p>
        ) : null}
      </div>
    </div>
  );
}

export default ParticipantDetails;
